import { Component, Input, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RichEditorComponent } from 'src/app/shared/components/rich-editor/rich-editor';
import { MatButtonModule } from '@angular/material/button';
import { getRichTextLength } from 'src/app/shared/helpers/rich-text';

export interface RichEditorDialogData {
    title: string;
    description: string;
    maxLength: number;
}

@Component({
    selector: 'nova-rich-editor-dialog-component',
    templateUrl: './rich-editor-dialog-component.html',
    styleUrls: ['./rich-editor-dialog-component.scss'],
    standalone: true,
    imports: [MatIconModule, RichEditorComponent, MatDialogModule, MatButtonModule]
})
export class RichEditorDialogComponent implements OnInit {
    @Input() title = '';
    @Input() note: string;
    @Input() maxLength: number = null;

    description = '';
    isDescriptionValid = true;

    constructor(@Optional() @Inject(MAT_DIALOG_DATA) private readonly _data: RichEditorDialogData | null) {}

    ngOnInit(): void {
        this.maxLength = this._data?.maxLength ?? this.maxLength ?? 1500;
        this.title = this._data?.title ?? this.title ?? '';
        this.description = this._data?.description ?? this.note ?? '';
        this.isDescriptionValid = getRichTextLength(this.description) <= this.maxLength;
    }

    setDescriptionValidity(isValid: boolean): void {
        this.isDescriptionValid = isValid;
    }

    isSaveDisabled(): boolean {
        return !this.isDescriptionValid;
    }

    getResult(cancelled = false): unknown {
        if (cancelled) {
            return null;
        }

        return this.description;
    }
}
